/** Dashboard-widgettyp → RBAC feature-kod */
export const DASHBOARD_WIDGET_FEATURE_BY_TYPE: Record<string, string> = {
  'vehicle-count': 'WIDGET_VEHICLE_COUNT',
  'inspection-due': 'WIDGET_INSPECTION_DUE',
  'leasing-expiring': 'WIDGET_LEASING_EXPIRING',
  'tax-due': 'WIDGET_TAX_DUE',
  'unplugged-vehicles': 'WIDGET_UNPLUGGED',
  'low-battery': 'WIDGET_LOW_BATTERY',
  'vehicle-status': 'WIDGET_VEHICLE_STATUS',
  'service-due': 'WIDGET_SERVICE_DUE',
  'service-cost': 'WIDGET_SERVICE_COSTS',
  'my-assignments': 'WIDGET_MY_ASSIGNMENTS',
  'my-bookings': 'WIDGET_MY_BOOKINGS',
};

/** Endast global admin — ingen WIDGET_*-RBAC */
export const GLOBAL_ADMIN_ONLY_DASHBOARD_WIDGETS = new Set(['gps-data-lag']);

export function getDashboardWidgetFeatureCode(widgetType: string): string | undefined {
  return DASHBOARD_WIDGET_FEATURE_BY_TYPE[widgetType];
}

/** assignment_categories.code → widget RBAC (dashboard tilldelningsöverlag) */
export const ASSIGNMENT_CATEGORY_WIDGET_FEATURE: Record<string, string> = {
  INSPECTION: 'WIDGET_INSPECTION_DUE',
  TAX: 'WIDGET_TAX_DUE',
  LEASING: 'WIDGET_LEASING_EXPIRING',
  LOW_BATTERY: 'WIDGET_LOW_BATTERY',
  UNPLUGGED_DEVICE: 'WIDGET_UNPLUGGED',
};

export function getWidgetFeatureForAssignmentCategory(
  categoryCode: string
): string | undefined {
  return ASSIGNMENT_CATEGORY_WIDGET_FEATURE[categoryCode.trim().toUpperCase()];
}
